import { createSlice } from "@reduxjs/toolkit";

export const warehousesSupplyInitialState = {
  filters: {
    brandIds: [],
    subjectIds: [],
    productIds: [],
    barcodeIds: [],
    categoryIds: [],
  },

  podsortBarcodes: [], // deprecated, to be deleted
  supplyDates: [],
  excludeBarcodeIdArray: [],
  alterQuantity: {},
  currentStep: 1, // deprecated
  currentSupplyId: 0,
  excludeBarcodePairs: [], // pair: barcode + barcodeId
  supplyDatesFromBackend: [],
  excludeRegionsArray: [],
};

function toBase64(str) {
  const bytes = new TextEncoder().encode(str);
  let binary = "";
  bytes.forEach(b => (binary += String.fromCharCode(b)));
  return btoa(binary);
}

function generateTripletKey(date, warehouseName, barcodeId) {
  const str = `${date}|${warehouseName}|${barcodeId}`;
  return toBase64(str);
}

const warehousesSupplySlice = createSlice({
  name: "warehousesSupply",
  initialState: warehousesSupplyInitialState,
  reducers: {
    resetWarehouseSupplyState(state, action) {
      return warehousesSupplyInitialState;
    },
    updateSupplyDatesFromBackend(state, action) {
      state.supplyDatesFromBackend = action.payload;
    },
    updateExcludeBarcodePairs(state, action) {
      state.excludeBarcodePairs = action.payload;
    },
    updateCurrentSupplyId(state, action) {
      state.currentSupplyId = action.payload;
    },
    updateExcludeBarcodeIdArray(state, action) {
      state.excludeBarcodeIdArray = action.payload;
    },
    updateExcludeRegionsArray(state, action) {
      state.excludeRegionsArray = action.payload;
    },
    updateCurrentStep(state, action) { 
      state.currentStep = action.payload;
    },
    updateSupplyFilter(state, action) {
      const { filterName, value } = action.payload;
      state.filters[filterName] = value;
    },
    resetSupplyFilters(state) {
      state.filters = warehousesSupplyInitialState.filters;
    },
    updatePodsortBarcodes(state, action) {
      state.podsortBarcodes = action.payload;
    },
    addSupplyDate: (state, action) => {
      state.supplyDates.push(action.payload);
    },
    resetSupplyDates: state => {
      state.supplyDates = [];
    },
    initializeSelectedPerCluster: (state, action) => {
      const { id, selectedPerCluster } = action.payload;
      const target = state.supplyDates.find(item => item.id === id);
      if (target) {
        target.selectedPerCluster = selectedPerCluster;
      }
    },
    initializeRecommendedPerCluster: (state, action) => {
      const { id, recommendedPerCluster } = action.payload;
      const target = state.supplyDates.find(item => item.id === id);
      if (target) {
        target.recommendedPerCluster = recommendedPerCluster;
      }
    },
    updateSelectedWarehouse: (state, action) => {
      const { id, clusterName, warehouseName } = action.payload;
      const target = state.supplyDates.find(item => item.id == id);
      if (target) {
        target.selectedPerCluster = {
          ...target.selectedPerCluster,
          [clusterName]: warehouseName,
        };
      }
    },
    updateAlterQuantity: (state, action) => {
      const { date, warehouseName, barcodeId, newQuantity } = action.payload;
      const key = generateTripletKey(date, warehouseName, barcodeId);
      state.alterQuantity[key] = {
        date,
        warehouse_name: warehouseName,
        barcode_id: barcodeId,
        quantity: newQuantity,
      };
    },
  },
});

export const {
  resetWarehouseSupplyState,
  updateSupplyDatesFromBackend,
  updateExcludeBarcodePairs,
  updateCurrentSupplyId,
  updateExcludeBarcodeIdArray,
  updateCurrentStep,
  addSupplyDate,
  resetSupplyDates,
  initializeSelectedPerCluster,
  initializeRecommendedPerCluster,
  updateSelectedWarehouse,
  updateSupplyFilter,
  resetSupplyFilters,
  updatePodsortBarcodes,
  updateAlterQuantity,
  updateExcludeRegionsArray,
} = warehousesSupplySlice.actions;

export default warehousesSupplySlice.reducer;
